import { motion } from "framer-motion";
import { CrmProvider } from '../../hooks/CrmContext'
import BasePage from '../basePage'
import { Drawer } from './Drawer'
import { StageList } from './StageList'

import { TabsList } from './TabsList'

import { Container } from './styles'
import { useMenu } from "../../store/global/useMenu";
import { PhoneCall } from "lucide-react";

export function Crm() {
  const menuSize = useMenu(st => st.data.size)

  return (
    <BasePage pageTitle={<><PhoneCall className='w-7 h-7' />CRM</>}>
      <CrmProvider>
        <Drawer />
        <motion.div
          initial={{ width: `calc(100vw - 2rem - ${menuSize})` }}
          animate={{ width: `calc(100vw - 2rem - ${menuSize})` }}
          transition={{ duration: 0.3 }}
        >
          <Container container spacing={3}>
            <TabsList />
            <StageList />
          </Container>
        </motion.div>
      </CrmProvider>
    </BasePage >
  )
}
